import { createApp } from 'vue';
import PngToWebpConverter from '../Components/PngToWebpConverter.vue';

const root = document.getElementById('png-to-webp-converter');
if (root) {
  createApp(PngToWebpConverter).mount('#png-to-webp-converter');
}
